module.exports = __webpack_public_path__ + "img/math_symbol.2292e105.jpg";